export default {
    utils: {
        /**
         * Url 'http://127.0.0.1:8000/order_platform...'
         * 截掉前面的 http://127.0.0.1:8000
         */
        handleOrderUrl(url) {
            if (!url) {
                return url
            }

            const index = url.indexOf('order_platform')
            if (index > -1) {
                return url.slice(index - 1)
            } else {
                return url
            }

        },

        requiredValidator(rule, value, callback) {
            if (!value) {
                callback(new Error('必填项'));
            } else {
                callback();
            }
        },
        requiredRules: [
            {
                validator: (rule, value, callback) => {
                    if (!value) {
                        callback(new Error('必填项'));
                    } else {
                        callback();
                    }
                }, trigger: 'blur'
            },
        ]

    },
    install(Vue) {
        Vue.prototype.$utils = this.utils
    }
}
